import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { FileSearchOutlined, RightOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import Icons from "components/icons";
import { Localize } from "components/service";

import './sidebar.scss';


const Sidebar = ({ appParams, setToggleSider }) => {

    let {
        selectedKeys = [ 'dashboard' ],
        openKeys = [ 'dashboard' ]
    } = appParams.activeMenu;

    const [ openSubMenu, setOpenSubMenu ] = useState(openKeys);

    useEffect(() => {
        // Check if the new selectedKeys contain child items that need parent to stay open
        const graphicStorageNeedsParentOpen = selectedKeys.some(key =>
            key === 'graphic-packings' ||
            key === 'graphic-warehouse' ||
            key === 'graphic-warehouse-shelves' ||
            key === 'graphic-storage-exhibitions' ||
            key === 'graphic-storage-main'
        );

        const settingsNeedsParentOpen = selectedKeys.some(key =>
            key === 'settings-languages' ||
            key === 'settings-translation-ai-usage' ||
            key === 'settings-translation-ai-requests'
        );

        // Also check if we're on exhibitions page but came from graphic context
        const isExhibitionsFromGraphic = selectedKeys.includes('exhibitions') &&
            window.location.search.includes('context=graphic');

        let nextOpenKeys = openKeys;

        if (graphicStorageNeedsParentOpen || isExhibitionsFromGraphic)
        {
            nextOpenKeys = [ ...new Set([ ...nextOpenKeys, 'graphic-storage' ]) ];
        }

        if (settingsNeedsParentOpen)
        {
            nextOpenKeys = [ ...new Set([ ...nextOpenKeys, 'settings' ]) ];
        }

        setOpenSubMenu(nextOpenKeys);

    }, [ appParams.activeMenu, openKeys, selectedKeys ]);

    const handleMenuSelect = ({ key, keyPath }) => {
        // Keep submenu open when selecting child items
        if (keyPath.length > 1)
        {
            const parentKey = keyPath[ keyPath.length - 1 ];
            if (!openSubMenu.includes(parentKey))
            {
                setOpenSubMenu(prev => {
                    const newOpenKeys = [ ...prev, parentKey ];
                    return newOpenKeys;
                });
            } else
            {
            }
        } else
        {
        }
    };


    const items = [
        {
            key: 'exhibitions',
            label: <Link to="/exhibitions"><Icons.Events /><Localize>MENUS.Label_Exhibitions</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'stands-global',
            label: <Link to="/stands-global"><FileSearchOutlined style={ { transform: 'scale(0.85)', width: 27 } } /><Localize>MENUS.Label_GlobalStandSearch</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'users',
            label: <Link to="/users"><Icons.Users /><Localize>MENUS.Label_Users</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'subcontractors',
            label: <Link to="/subcontractors"><Icons.SubContractors /><Localize>MENUS.Label_Subcontractors</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'staff-management',
            label: <Link to="/staff-management"><Icons.StaffManagement /><Localize>MENUS.Label_StaffManagement</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'graphic-storage',
            label: <span className="sidebar-submenu-label"><Icons.Crafts.CollectGraphicsStroke /><Localize>MENUS.Label_GraphicWarehouse</Localize></span>,
            children: [
                {
                    key: 'graphic-storage-main',
                    label: <Link to="/graphic-storage">{ selectedKeys.includes('graphic-storage-main') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_GraphicStorage</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'graphic-packings',
                    label: <Link to="/graphic-packings">{ selectedKeys.includes('graphic-packings') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_GraphicPackings</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'graphic-warehouse',
                    label: <Link to="/graphic-warehouse">{ selectedKeys.includes('graphic-warehouse') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_GraphicWarehouseOverview</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'graphic-warehouse-shelves',
                    label: <Link to="/graphic-shelves">{ selectedKeys.includes('graphic-warehouse-shelves') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_ShelfUtilization</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
            ]
        },
        {
            key: 'settings',
            label: <span className="sidebar-submenu-label"><Icons.Gear /><Localize>MENUS.Label_Settings</Localize></span>,
            children: [
                {
                    key: 'settings-languages',
                    label: <Link to="/settings/languages">{ selectedKeys.includes('settings-languages') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_Languages</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'settings-translation-ai-usage',
                    label: <Link to="/settings/translation-ai-usage">{ selectedKeys.includes('settings-translation-ai-usage') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_TranslationAiUsage</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'settings-translation-ai-requests',
                    label: <Link to="/settings/translation-ai-requests">{ selectedKeys.includes('settings-translation-ai-requests') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_TranslationAiRequests</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
            ]
        },
        {
            key: 'last-minute',
            label: <Link to="/last-minute"><Icons.LastMin /><Localize>MENUS.Label_LastMin</Localize></Link>,
            className: 'border-menu-item',
            onClick: () => setToggleSider(true),
            // disabled: true,
        },
    ];


    return (
        <>
            <Menu
                items={ items }
                className='sidebar-menu'
                theme="dark"
                mode="inline"
                selectedKeys={ selectedKeys }
                openKeys={ openSubMenu }
                onOpenChange={ (keys) => {
                    setOpenSubMenu(keys);
                } }
                onSelect={ handleMenuSelect }
                style={ { borderRight: 0 } }>
            </Menu>
        </>
    );
};

export default Sidebar;
